import styled from "styled-components";
import SntMarkdown from "@widgets/markdown/SntMarkdown";

interface ChatBubbleProps {
  type: "user" | "ai" | "system";
  children?: React.ReactNode;
  markdown?: string;
}

const StyledBubble = styled.div<{ $type: "user" | "ai" | "system" }>`
  max-width: 85%;
  padding: 0.75rem 1rem;
  border-radius: 1rem;
  word-wrap: break-word;

  ${({ $type }) =>
    $type === "user" &&
    `
    align-self: flex-end;
    margin-left: auto;
    background-color: var(--bs-primary);
    color: white;
    border-bottom-right-radius: 0.25rem;
  `}

  ${({ $type }) =>
    $type === "ai" &&
    `
    align-self: flex-start;
    background-color: var(--bs-light);
    border: 1px solid var(--bs-border-color);
    border-bottom-left-radius: 0.25rem;
  `}

  ${({ $type }) =>
    $type === "system" &&
    `
    align-self: center;
    max-width: 95%;
    background-color: var(--bs-warning-bg-subtle);
    border: 1px solid var(--bs-warning-border-subtle);
    font-size: 0.875rem;
  `}
`;

const ChatBubble = ({ type, children, markdown }: ChatBubbleProps) => {
  return (
    <StyledBubble $type={type} className={`chat-message ${type}`}>
      {markdown ? <SntMarkdown text={markdown} height="auto" /> : children}
    </StyledBubble>
  );
};

export default ChatBubble;
